/**
 * Via6 base theme registry.
 *
 * Flat export (no spreads) so the preview server's static registry
 * parser can enumerate all slots.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  FloorplansList,
  AmenitiesList,
  GalleryApartments,
  GallerySeparator,
  GalleryCommunity,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  HomeSlider,
  DividerBG,
  DividerImage,
  AmenitiesGrid,
  AmenitiesListCommunity,
  AmenitiesListInterior,
  PetCallout,
  HomeMap,
  NeighborhoodTour,
  ReviewsSlider,
  InteriorIntro,
  InteriorBody,
  FloorPlansHero,
  AmenitiesHero,
  VirtualTourHero,
  GalleryHero,
  PetPolicyHero,
  NeighborhoodHero,
  ContactHero,
  ResidentAccessHero,
  ScheduleATourHero,
  ReviewsHero,
  InteractiveMapHero,
  PrivacyPolicyHero,
  SitemapHero,
  AccessibilityHero,
  ApplyNowHero,
  ThankYouHero,
  FRCHero,
  GalleryTabs,
  FAQHero,
  FAQList,
} from './components';

export const registry = {
  Header: Header,
  Hero: Hero,
  PropertyOverview: PropertyOverview,
  SpecialOffers: SpecialOffers,
  CTASection: CTASection,
  TabbedCallouts: TabbedCallouts,
  FloorplansList: FloorplansList,
  AmenitiesList: AmenitiesList,
  GalleryApartments: GalleryApartments,
  GallerySeparator: GallerySeparator,
  GalleryCommunity: GalleryCommunity,
  NeighborhoodMap: NeighborhoodMap,
  VirtualTourEmbed: VirtualTourEmbed,
  ContactForm: ContactForm,
  ContactMap: ContactMap,
  ScheduleTourForm: ScheduleTourForm,
  Fees: Fees,
  PetPolicy: PetPolicy,
  PageHero: PageHero,
  PageBlurb: PageBlurb,
  HeroSolidBG: HeroSolidBG,
  Reviews: Reviews,
  ReviewsCallout: ReviewsCallout,
  PinnedCallouts: PinnedCallouts,
  SocialFollow: SocialFollow,
  SpecialOfferBanner: SpecialOfferBanner,
  ResidentAccess: ResidentAccess,
  AccessibilityStatement: AccessibilityStatement,
  PrivacyPolicyContent: PrivacyPolicyContent,
  SitemapContent: SitemapContent,
  HyperlocalHero: HyperlocalHero,
  HyperlocalPageCopy: HyperlocalPageCopy,
  ThankYouContent: ThankYouContent,
  FutureResidentsClub: FutureResidentsClub,
  ApartmentSyncSection: ApartmentSyncSection,
  Footer: Footer,
  Navigation: Navigation,
  InteractiveMapSection: InteractiveMapSection,
  HomeSlider: HomeSlider,
  DividerBG: DividerBG,
  DividerImage: DividerImage,
  AmenitiesGrid: AmenitiesGrid,
  AmenitiesListCommunity: AmenitiesListCommunity,
  AmenitiesListInterior: AmenitiesListInterior,
  PetCallout: PetCallout,
  HomeMap: HomeMap,
  NeighborhoodTour: NeighborhoodTour,
  ReviewsSlider: ReviewsSlider,
  InteriorIntro: InteriorIntro,
  InteriorBody: InteriorBody,
  FloorPlansHero: FloorPlansHero,
  AmenitiesHero: AmenitiesHero,
  VirtualTourHero: VirtualTourHero,
  GalleryHero: GalleryHero,
  PetPolicyHero: PetPolicyHero,
  NeighborhoodHero: NeighborhoodHero,
  ContactHero: ContactHero,
  ResidentAccessHero: ResidentAccessHero,
  ScheduleATourHero: ScheduleATourHero,
  ReviewsHero: ReviewsHero,
  InteractiveMapHero: InteractiveMapHero,
  PrivacyPolicyHero: PrivacyPolicyHero,
  SitemapHero: SitemapHero,
  AccessibilityHero: AccessibilityHero,
  ApplyNowHero: ApplyNowHero,
  ThankYouHero: ThankYouHero,
  FRCHero: FRCHero,
  GalleryTabs: GalleryTabs,
  FAQHero: FAQHero,
  FAQList: FAQList,
} satisfies ComponentRegistry;

export default registry;
